import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { AdminRecipe, AdminRecipePayload, CountryOption, RecipeCategory, SearchResult } from '../models/admin-recipe.models';

@Injectable({ providedIn: 'root' })
export class AdminRecipesService {
  private readonly http = inject(HttpClient);

  getMyRecipes(page = 0, size = 100): Observable<SearchResult<AdminRecipe>> {
    const params = new HttpParams()
      .set('page', `${page}`)
      .set('size', `${size}`)
      .set('sort', 'createdAt,desc');

    return this.http.get<SearchResult<AdminRecipe>>(`${API_BASE_URL}/recipes/owner`, { params });
  }

  getRecipesByStatus(status: string, page = 0, size = 100): Observable<SearchResult<AdminRecipe>> {
    const params = new HttpParams()
      .set('status', status)
      .set('page', `${page}`)
      .set('size', `${size}`);

    return this.http.get<SearchResult<AdminRecipe>>(`${API_BASE_URL}/v1/management/moderation/recipes`, { params });
  }

  createRecipe(payload: AdminRecipePayload): Observable<AdminRecipe> {
    return this.http.post<AdminRecipe>(`${API_BASE_URL}/recipes`, payload);
  }

  updateRecipe(recipeId: number, payload: AdminRecipePayload): Observable<AdminRecipe> {
    return this.http.put<AdminRecipe>(`${API_BASE_URL}/recipes/${recipeId}`, payload);
  }

  deleteRecipe(recipeId: number): Observable<void> {
    return this.http.delete<void>(`${API_BASE_URL}/recipes/${recipeId}`);
  }

  getCategories(page = 0, size = 200): Observable<SearchResult<RecipeCategory>> {
    return this.http.get<SearchResult<RecipeCategory>>(`${API_BASE_URL}/categories/${page}/${size}`);
  }

  getCountries(): Observable<CountryOption[]> {
    return this.http.get<CountryOption[]>(`${API_BASE_URL}/statics/countries`);
  }
}
